import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router/';
import { AppStateFacade } from '@app-state';
import { ITenant } from '@models';
import { AuthService } from '@services';

import {
    BehaviorSubject,
    Observable,
} from 'rxjs';
import {
    finalize,
    switchMapTo,
} from 'rxjs/operators';

@Component({
    templateUrl: './tenant-select.page.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TenantSelectPageComponent {
    public tenants$: Observable<ITenant[]>;
    public loading$ = new BehaviorSubject(false);

    constructor(
        private _router: Router,
        private _authService: AuthService,
        private _appState: AppStateFacade,
    ) {
        this.tenants$ = _authService.getExternalUserTenants();
    }

    public externalLogin(tenant: ITenant) {
        this.loading$.next(true);

        this._authService.externalLoginTenant(tenant.name)
            .pipe(
                finalize(
                    () => this.loading$.next(false),
                ),
                switchMapTo(this._appState.user.ensureCorrectIdentity()),
                switchMapTo(this._appState.user.fetch()),
            )
            .subscribe(() => {
                this._router.navigate(['/'], { replaceUrl: true });
            });
    }
}
